//@ts-nocheck
import { useEffect, useRef } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { IndividualCarouselTitle } from "../../../constants";
import { IndividualIntervalData, ItemIntervalData } from "../../../data/bonusUi/Carousel";
import { dynamicImage } from "../../../utils";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { Image } from "../../../coreComponents/Image";

// This component displays a carousel with individual autoplay intervals for each slide.
const IndividualInterval = () => {
  const swiperRef = useRef(null);

  useEffect(() => {
    if (!swiperRef.current) return;

    const swiperInstance = swiperRef.current.swiper;

    // Function to update autoplay delay based on the current slide's interval.
    const updateAutoplayDelay = () => {
      const currentSlideIndex = swiperInstance.realIndex;
      const currentInterval = IndividualIntervalData[currentSlideIndex].interval; // Fetch corresponding interval.
      swiperInstance.params.autoplay.delay = currentInterval; // Update autoplay delay.
      swiperInstance.autoplay.stop();
      swiperInstance.autoplay.start(); // Restart autoplay with the new delay.
    };

    swiperInstance.on("slideChange", updateAutoplayDelay);

    return () => {
      swiperInstance.off("slideChange", updateAutoplayDelay); // Cleanup event listener on unmount.
    };
  }, []);
  return (
    <Col xl="6" xs="12">
      <Card>
        <CommonCardHeader title={IndividualCarouselTitle} span={ItemIntervalData} />
        <CardBody>
          <Swiper ref={swiperRef} modules={[Autoplay, Navigation]} navigation loop autoplay={{ delay: IndividualIntervalData[0].interval }} slidesPerView={1}>
            {IndividualIntervalData?.map((item, index) => (
              <SwiperSlide key={index}>
                <div>
                  <Image src={dynamicImage(item.image)} alt="drawing-room" className="d-block w-100" />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </CardBody>
      </Card>
    </Col>
  );
};

export default IndividualInterval;